import { useKeycloak } from "@react-keycloak/web";
import React from "react";
import ForbiddenContent from "./ForbiddenScreenContent";

export default function Forbidden() {
  const { keycloak } = useKeycloak();

  return <ForbiddenContent keycloak={keycloak} />;
}
